import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { LogoutButtonComponent } from './logout-button/logout-button.component';
import { LogoutComponent } from './logout/logout.component';

@NgModule({
  declarations: [ChangePasswordComponent, LoginComponent, LogoutButtonComponent, LogoutComponent],
  imports: [CommonModule, ReactiveFormsModule, RouterModule],
  exports: [LogoutButtonComponent, LogoutComponent],
})
export class AuthModule {}
